import { InputHTMLAttributes, ReactNode, forwardRef } from 'react'
import clsx from 'clsx'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  icon?: string
  leftIcon?: ReactNode
  helperText?: string
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, icon, leftIcon, helperText, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-')
    const hasLeftIcon = !!(icon || leftIcon)

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            {label}
          </label>
        )}
        <div className="relative">
          {leftIcon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex items-center justify-center w-5">
              {leftIcon}
            </div>
          )}
          {icon && !leftIcon && (
            <i
              className={`fas ${icon} absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none w-5 text-center`}
            ></i>
          )}
          <input
            ref={ref}
            id={inputId}
            className={clsx(
              'input',
              hasLeftIcon && 'pl-10',
              error && 'input-error',
              className
            )}
            {...props}
          />
        </div>
        {error ? (
          <p className="mt-1 text-sm text-red-500 flex items-center gap-1">
            <i className="fas fa-exclamation-circle text-xs"></i>
            {error}
          </p>
        ) : helperText ? (
          <p className="mt-1 text-sm text-gray-500">{helperText}</p>
        ) : null}
      </div>
    )
  }
)

Input.displayName = 'Input'

export default Input
